import React, { Component } from 'react';
import { browserHistory }   from 'react-router';
import './../../css/Banner.css';

class Logo extends Component
{

    goHome = () => {
        browserHistory.push('/');
    };

    render = () => {
        return (
            <div className="app-logo">
                <img
                    className="app-logo-img center-y tap-event"
                    src={ this.props.logo }
                    alt="Home"
                    onTouchTap={ this.goHome }
                />
            </div>
        );
    }

}

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Banner/Logo.js